import React, { memo } from 'react'
import { HeadingText, BodyText } from '@paypalcorp/pp-react'

const DsrBanner = memo((props) => {
  return (
    <div className="introSection">
      <HeadingText size="lg">{props.header}</HeadingText>
      <BodyText className="page-introduction">{props.description}</BodyText>
    </div>
  )
})
DsrBanner.displayName = 'ZettlePageIntroduction'

export default DsrBanner
